import {Component, Inject, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ResultadoRegraService} from "../../resultado-regra/resultado-regra.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {indicate} from "../util/loading-indicate";
import {TipoExecucao} from "../../resultado-regra/resultado-regra/tipo-execucao";
import {ResultadoCarteira} from "../../processamento/resultado-carteira";

@Component({
  selector: 'app-modal-ultimos-dez-processamento',
  templateUrl: './modal-ultimos-dez-processamento.component.html',
  styleUrls: ['./modal-ultimos-dez-processamento.component.scss']
})
export class ModalUltimosDezProcessamentoComponent implements OnInit {

  resultadoCarteiras: ResultadoCarteira[] = [];
  tipoExecucao: string = TipoExecucao.POSFATO.name;

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  form: FormGroup;

  constructor(
    public formBuilder: FormBuilder,
    private readonly resultadoRegraService: ResultadoRegraService,
    @Inject(MAT_DIALOG_DATA) private carteiraId: number,
    public dialogRef: MatDialogRef<ModalUltimosDezProcessamentoComponent>,
  ) { }

  ngOnInit(): void {
       this.detail(this.carteiraId);
   }

  detail(carteiraId: number) {
    this.resultadoRegraService.lastTenProccess(carteiraId)
      .pipe(indicate(this.loading$))
      .subscribe(
      data => {
        this.resultadoCarteiras = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }


}
